// getIntercomArticleData.js
'use strict';
import { fromJS } from 'immutable';
import { Collection } from 'immutable';
import createCachedSelector from '../resource/createCachedSelector.js';

/**
 * Select intercom article data by id
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} id - intercom article id.
 * @param {string} dataKey - select key.
 * @return {RETURN_TYPE} The selected intercom article data.
 */
const getIntercomArticleData = createCachedSelector(
  (state, selectPath) =>
    state.getIn(['intercomArticles', ...selectPath]) || fromJS({}),
  (state, selectPath, dataKey) => dataKey,
  (faq, dataKey = '') => {
    const result = faq?.get(dataKey);
    return result instanceof Collection ? result.toJS() : result;
  }
)((state, selectPath, dataKey = '') => `${selectPath.join(':')}:${dataKey}`);

export default getIntercomArticleData;
